import localforage from 'localforage';

class DB {
	favStore = null;
	viewSettingStore = null;

	init = () => {
	  this.viewSettingStore = localforage.createInstance({
	    name: 'GoTracker',
	    storeName: 'viewsettings',
	    description: 'stores view settings like language'
	  });

	  this.favStore = localforage.createInstance({
	    name: 'GoTracker',
	    storeName: 'fav',
	    description: 'stores favourite pages'
	  });

	// console.log(`${this.viewSettingStore ? this.viewSettingStore.storeName : 'viewSettingStore not '} initialized`);
	// console.log(`${this.favStore ? this.favStore.storeName : 'favStore not '} initialized`);
	}
}

const db = new DB();

export default db;
